import { render, staticRenderFns } from "./Tabs.vue?vue&type=template&id=031e540f&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=ts"
export * from "./Tabs.vue?vue&type=script&lang=ts"
import style0 from "./Tabs.vue?vue&type=style&index=0&id=031e540f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031e540f",
  null
  
)

export default component.exports